import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../../src/environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.azureSingleSignOnClientId,
      authority: environment.azureSingleSignOnAuthority,
      redirectUri: environment.azureSingleSignOnRedirectUri,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  });
}

export const protectedResourceMap = new Map<string, Array<string>>([
  [`${environment.microsoftGraphBaseUrl}`, ['user.read']],
  [`${environment.microsoftGraphBaseUrl}/photo/$value`, ['user.read']],
  [environment.azureBackendApiUrlBaseAddress, [environment.azureBackendApiScope]],
]);

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap,
};

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}